import { Link, Modal } from "@smart/itops-sb-design-system-dom";
import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";

type NoFormsModalProps = {
  open: boolean;
  onSubmit: () => void;
};
export const NoFormsModal = ({ open, onSubmit }: NoFormsModalProps) => {
  const { hostType, host } = useSmokeballApp();
  const formBuilderText = `${hostType === "web" ? "Settings" : "File"} > Intake Forms`;

  const formBuilderLink =
    host?.isEarlierThanVersion({ major: 9, minor: 5 }) && hostType !== "web" ? (
      formBuilderText
    ) : (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link
        dataTestId="form-builder-url"
        onClick={() => {
          host?.navigate({ target: "intake-form-builder" });
          onSubmit();
        }}
        text={formBuilderText}
      />
    );

  return (
    <Modal
      header={{
        icon: "regularCircleInfo",
        text: "No active intake forms available",
        iconBgColor: "bg-cyan-140",
      }}
      footer={{
        buttons: [
          {
            text: "Ok",
            onClick: onSubmit,
          },
        ],
      }}
      open={open}
      closeOptions={{
        escapeKey: false,
        clickOutside: false,
      }}
    >
      <p>
        There are no active Intake Forms available for this matter. Please go to{" "}
        {formBuilderLink} to create and activate a form.
      </p>
    </Modal>
  );
};
